import SVTAPI from './svtapi';

class PreStorageEvent extends SVTAPI {
  /**
   * Initializes the API for an existing pre storage event.
   *
   * @param {number} [pid] - The pid of an existing storageEvent, if applicable
   */
  constructor(pid = false) {
    super('/pre-storage-event');
    if(pid) this._pid = pid;
  }

  /**
   * POST /pre-storage-event/
   * Creates a new pre storage event.
   *
   * @param {Object} data - The data to update
   *
   * @return {Object} - The server's response
   */
  post(data) {
    return super.post({ data });
  }

  /**
   * PATCH /pre-storage-event/:pid
   * Updates an existing pre storage event.
   *
   * @param {Object} data - The data to update
   *
   * @return {Object} - The server's response
   */
  patch(data) {
    return super.patch({ url: '/' + this._pid, data });
  }

  /**
   * DELETE /expense/:pid
   * Deletes an existing pre storage event.
   *
   * @param {Object} data - The data to update
   *
   * @returns {Object} - The server's response
   */
  remove(data) {
    return super.remove({ url: '/' + this._pid, data });
  }
}

export default PreStorageEvent;
